<div class="page">
  <div class='notification-heading'>
    <h1 class="page__heading">All Notifications</h1>
    <button kendoButton fillMode="outline" [svgIcon]="squareCheck" [themeColor]="'primary'"
      class="k-justify-content-right" *ngIf="allNotifications?.length" (click)="showAllReadWarning()">Mark All as
      Done/Read</button>
  </div>
  <kendo-grid [data]="gridView" [hideHeader]="true" [autoSize]="true"  [pageSize]="pageSize" [skip]="skip" [pageable]="{ buttonCount: 6, type: 'numeric', pageSizes: true }" (pageChange)="onPageChange($event)" >
    <ng-template kendoGridToolbarTemplate position="top">
      <div class=toolbar-wrapper>
        <kendo-textbox placeholder="Search Student ID" style="width: 100%;"
          (valueChange)="handleNotificationSearch($event)">
          <ng-template kendoTextBoxPrefixTemplate>
            <kendo-svg-icon [icon]="searchIcon" size="medium" themeColor="primary"></kendo-svg-icon>
          </ng-template>
        </kendo-textbox>
      </div>
    </ng-template>
    <kendo-grid-column [style]="{padding: '0'}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-notification-content [content]="[dataItem]"></app-notification-content>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
    <div class="loading-container">
      <div class="loading-panel-mask"></div>
      <kendo-loader *ngIf="loadSpinner" type="converging-spinner"></kendo-loader>
    </div>